import React from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'

import './Home.css'

export default class Home extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loaded: false,
            ficha: {
                usuario: localStorage.nome,
            },
            despachos: [],
            registrados: [],
            tvs: []
        }
    }

    componentDidMount() {
        const url = '/api/paf/historico'
        const nome = this.state.ficha
        axios.post(url, nome)
            .then(resp => {
                this.setState({ despachos: resp.data.despachos })
                this.setState({ registrados: resp.data.registrados })
                this.setState({ tvs: resp.data.tvs })
                this.setState({ loaded: true })
            })
            .catch(error => {
                alert(error)
            }
            )
    }

    render() {
        return (
            <div className="container mx-auto">
                <h5 className="pt-3 text-left" style={{color: "#036666", marginLeft: "1vw"}}>PAFs REGISTRADOS</h5>
                <div className="text-center mx-auto tabelaHome" style={{ overflowX: "hidden" }}>
                    <table className="table">
                        <thead>
                            <tr>
                                <th>NUMERO</th>
                                <th>SETOR</th>
                                <th>ESTABELECIMENTO</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderPafs()}
                        </tbody>
                    </table>
                </div>

                <h5 className="pt-3 text-left" style={{color: "#036666", marginLeft: "1vw"}}>TERMOS DE VISITA</h5>
                <div className="text-center mx-auto tabelaHome" style={{ overflowX: "hidden" }}>
                    <table className="table">
                        <thead>
                            <tr>
                                <th>NUMERO</th>
                                <th>ESTABELECIMENTO</th>
                                <th>TIPO</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderTvs()}
                        </tbody>
                    </table>
                </div>

                <h5 className="pt-3 text-left" style={{color: "#036666", marginLeft: "1vw"}}>DESPACHOS</h5>
                <div className="text-center mx-auto tabelaHome mb-5" style={{ overflowX: "hidden" }}>
                    <table className="table">
                        <thead>
                            <tr>
                                <th>NUMERO</th>
                                <th>ESTABELECIMENTO</th>
                                <th>DESTINO</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderDespachos()}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    renderPafs() {
        if (this.state.loaded) {
            return this.state.registrados.reverse().map(ficha => {
                return (
                    <tr key={ficha.numero}>
                        <td>{ficha.numero}</td>
                        <td>{ficha.setor}</td>
                        <td>{ficha.estabelecimento}</td>
                        <td>
                            <Link to={`/documentosPaf/${ficha._id}`} target="_blank" params={ficha}>
                                <button style={{
                                    border: "none", backgroundColor: "#28a745",
                                    paddingTop: "5px", paddingBottom: "5px",
                                    paddingLeft: "12px", paddingRight: "12px",
                                    borderRadius: "15px", color: "#FFFF"
                                }}>Abrir</button>
                            </Link>
                        </td>
                    </tr>
                )
            })
        } else {
            return null
        }
    }

    renderTvs() {
        if (this.state.loaded) {
            return this.state.tvs.reverse().map(ficha => {
                return ficha.documentos.reverse().map(doc => {
                    return (
                        <tr key={ficha.numero}>
                            <td>{ficha.numero}</td>
                            <td>{ficha.estabelecimento}</td>
                            <td>{doc.tipo}</td>
                            <td>
                                <Link to={`/documentosPaf/${ficha._id}`} target="_blank" params={ficha}>
                                    <button style={{
                                        border: "none", backgroundColor: "#28a745",
                                        paddingTop: "5px", paddingBottom: "5px",
                                        paddingLeft: "12px", paddingRight: "12px",
                                        borderRadius: "15px", color: "#FFFF"
                                    }}>Abrir</button>
                                </Link>
                            </td>
                        </tr>
                    )
                })
            })
        } else {
            return null
        }
    }

    renderDespachos() {
        if (this.state.loaded) {
            return this.state.despachos.reverse().map(ficha => {
                return ficha.despachos.reverse().map(doc => {
                    return (
                        <tr key={ficha.numero}>
                            <td>{ficha.numero}</td>
                            <td>{ficha.estabelecimento}</td>
                            <td>{doc.destino}</td>
                            <td>
                                <Link to={`/documentosPaf/${ficha._id}`} target="_blank" params={ficha}>
                                    <button style={{
                                        border: "none", backgroundColor: "#28a745",
                                        paddingTop: "5px", paddingBottom: "5px",
                                        paddingLeft: "12px", paddingRight: "12px",
                                        borderRadius: "15px", color: "#FFFF"
                                    }}>Abrir</button>
                                </Link>
                            </td>
                        </tr>
                    )
                })
            })
        } else {
            return null
        }
    }
}